import { render, staticRenderFns } from "./priceTable.vue?vue&type=template&id=5dd7538d&scoped=true"
import script from "./priceTable.vue?vue&type=script&lang=js"
export * from "./priceTable.vue?vue&type=script&lang=js"
import style0 from "./priceTable.vue?vue&type=style&index=0&id=5dd7538d&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dd7538d",
  null
  
)

export default component.exports